<template>
<div id='Modals'>   
<modal-sector />
<modal-dirinit />
<modal-videotour />
<modal-limitededition />
<modal-share />
<modal-refer />
<modal-firma />
<modal-widget />
<modal-msg />
<modal-datosmember />
<modal-loyalty />
<modal-loyalty-terms />
<modal-transactions />
<modal-agentes />
<modal-applytemplateall />
<modal-transfer />
<modal-category />
<modal-beneficio />
<modal-qr />
<modal-signup />
<modal-blocked />
<modal-json />
<modal-crop />
<modal-image-editor />
<modal-planes />
<modal-payment />
<modal-churn />
<modal-linkcard-name />
<modal-move-linkcard />
<block-edit-modal />
<v-dialog/>
</div>
</template>

<script>
import BlockEditModal from '@/features/editor/bloques/BlockEditModal.vue'

export default {
  components: {
    'block-edit-modal': BlockEditModal,
  },
}
</script>

<style >
.v--modal{
border-radius:15px !important;
}
</style>